import moment from 'moment';
import { set } from 'lodash';

import { DATE_TIME_RULES } from 'ui-permit/src/constants';

import * as types from '../constants';

export const createSimpleRule = (ruleName, permit, divisionId, value) => {
  return {
    permit_id: permit.id,
    division_id: divisionId,
    name: ruleName,
    operation: 'None',
    start_date: moment().utc().clone().subtract(365, 'days'),
    end_date: moment().utc().clone().add(365, 'days'),
    target: 'None',
    type: -1,
    value
  };
};

export const transformPermit = (originalPermit) => {
  if (!originalPermit) {
    return {};
  }

  // re-organize the rules so they're indexable by name
  let rules = {};
  originalPermit.rules.forEach((x) => {
    const { name, ...rule } = x;
    if (DATE_TIME_RULES.find((y) => y === name)) {
      rule.value *= types.EPOCH_MULTIPLIER;
    }
    rules = Object.assign(rules, { [name]: rule });
  });

  set(originalPermit, "indexed_rules", rules);

  const permit = Object.assign({}, originalPermit);
  if (permit.divisions) {
    Object.keys(permit.divisions).forEach((divisionId) => {
      permit.divisions[divisionId].isStartingPoint = true;
      permit.divisions[divisionId].childDivisions = [];
    });
  }
  return permit;
};
